
import { computed, defineComponent, ref, toRefs, PropType } from "vue";

interface UserInfo {
  from_name: string;
  head_pic: string;
  id: string;
  name: string;
  out_userid: string;
  user_type: string;
}

interface PropData {
  factory_user_info: Array<UserInfo>;
  stores_user_info: Array<UserInfo>;
  copy_user_info: Array<UserInfo>;
}

export default defineComponent({
  name: "SeePerson",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object as PropType<PropData>,
      required: true
    }
  },
  emits: ["update:show"],
  setup(props, { emit }) {
    const { show, data } = toRefs(props);
    console.log(data.value);
    const popupShow = computed({
      get() {
        return show.value;
      },
      set(value) {
        emit("update:show", value);
      }
    });

    const value = ref("");
    const active = ref("staff");

    return {
      value,
      popupShow,
      active
    };
  }
});
